import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Constants } from "../../core/constants";
import { LoginAndUserManagerService } from "../../api/managers/login-and-user-manager.service";
import { UserRegistration } from "../../api/models/user-registration/user-registration.model";
import { LoggingService } from "../../services/logging.service";
import { LookupListService } from "../../services/lookup-list.service";

@Component({
    selector: "app-registration",
    templateUrl: "./registration.component.html",
    styleUrls: ["./registration.component.less"],
})
export class RegistrationComponent implements OnInit {
    businessName: string;
    address1: string;
    address2: string;
    city: string;
    states: string[];
    provinces: string[];
    //state: string;
    //country: string;
    stateOrProvinces: string[];
    countries: string[];
    zipCode: string;
    phone: string;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    confirmPassword: string;
    terms: boolean;

    error = "";
    showInputForState = false;

    showPrivacyPolicy = false;
    showTerms = false;

    isLoading = false;
    registerForm: FormGroup;
    passwordMsg:string;

    constructor(
        private router: Router,
        private loginAndUserManagerService: LoginAndUserManagerService,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.passwordMsg = Constants.Strings.PaaswordRequirementsMessage;

        this.registerForm = this.fb.group({
            businessName: ["", [Validators.required, Validators.maxLength(50)]],
            address1: ["", [Validators.required, Validators.maxLength(50)]],
            address2: ["", [Validators.maxLength(50)]],
            city: ["", [Validators.required, Validators.maxLength(50)]],
            zipCode: ["", [Validators.required, Validators.maxLength(10)]],
            phone: ["", [Validators.required, Validators.maxLength(14)]],
            country: ["", Validators.required],
            state: ["", [Validators.required, Validators.maxLength(50)]],
            firstName: ["", [Validators.required, Validators.maxLength(50)]],
            lastName: ["", [Validators.required, Validators.maxLength(50)]],
            email: ["", [Validators.required, Validators.email]],
            password: [
                "",
                [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.minLength(8),
                ],
            ],
            confirmPassword: [
                "",
                [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.minLength(8),
                ],
            ],
            terms: ["", Validators.required],
        });

        this.onFormValueChanges();

        this.states = LookupListService.getStatesList();
        this.provinces = LookupListService.getProvincesList();
        this.countries = LookupListService.getCountriesList();
        this.stateOrProvinces = this.states;

        this.registerForm.patchValue({
            country: this.countries[0],
            state: this.states[0],
        });
    }

    get registerFormControl() {
        return this.registerForm.controls;
    }
    private onFormValueChanges() {
        this.registerForm.valueChanges.subscribe(
            (changes: Partial<UserRegistration>) => {

            }
        );
    }
    onCountryChanged(selectedCountry) {
        this.getStatesOrProvinces(selectedCountry);
    }

    onlyNumberKey(event) {
        return event.charCode == 8 || event.charCode == 0
            ? null
            : event.charCode >= 48 && event.charCode <= 57;
    }

    onInputChange(event: string, labelId: string) {
        if (event) {
            this.phone = event;
            document.getElementById(labelId).classList.add("dispNone");
        } else {
            document.getElementById(labelId).classList.remove("dispNone");
        }
    }

    onRegister(form: FormGroup) {
        this.isLoading = true;
        const userRegistration = new UserRegistration(form.value);

        this.loginAndUserManagerService
            .registerUser(userRegistration)
            .subscribe(
                (user) => {
                    this.isLoading = false;
                    this.router.navigate(["/register/success"], {
                        queryParams: { email: form.value.email },
                    });
                },
                (error) => {
                    this.isLoading = false;
                    LoggingService.log(error["error"]["ModelState"]["Error"]);
                    this.error = error.error.ModelState.Error;
                }
            );
    }

    getStatesOrProvinces(country: string) {
        if (country.includes("United States")) {
            this.registerForm.patchValue({
                state: this.states[0],
            });
            this.showInputForState = false;
            this.stateOrProvinces = this.states;
        } else if (country.includes("Canada")) {
            this.registerForm.patchValue({
                state: this.provinces[0],
            });
            this.showInputForState = false;
            this.stateOrProvinces = this.provinces;
        } else {
            this.showInputForState = true;
            this.registerForm.patchValue({
                state: "",
            });
        }
    }

    togglePrivacyPolicy() {
        this.showPrivacyPolicy = !this.showPrivacyPolicy;
    }

    toggleTerms() {
        this.showTerms = !this.showTerms;
    }

    goToMain(e: Event) {
        this.router.navigate(["welcome"]);
    }
}
